import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z"
        fill="#E04F5F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.624 15.484a.39.39 0 01-.552-.553l8.36-8.36a.39.39 0 01.553.553L9.448 11.66c1.077.943 2.209 1.563 2.65 1.119.293-.295.749-.793 1.03-1.098.28-.304 3.296 1.74 2.638 2.329l-1.545 1.383c-1.36 1.217-4.07-.103-6.337-2.169l-2.26 2.26zm1.156-3.365l1.563-1.563C7.399 9.477 6.776 8.344 7.221 7.9c.295-.292.793-.748 1.098-1.028.304-.28-1.74-3.297-2.329-2.639L4.607 5.78c-1.218 1.36.105 4.072 2.173 6.34z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
